<template>
  <b-container class="blog-post">

    <b-row>
      <b-col md="10" offset-md="1">
        <br>
        <p class="blog-date">03/28/18</p>
        <h1>THE BEST COMMUNITY FACILITIES NEAR <br>NEW SEATON </h1>
        <div class="blog-content">
        <br>
        <p>Community centres are the hub of any town or city; a meeting or multi-purpose space
          that everyone in the area can benefit from. While most municipalities only have one community centre,
          Pickering is lucky enough to have five. With each location specializing in something different, you’ll love
          feeling so connected to the community and so close to a world of amenities when you’re living in your New
          Seaton home. Take advantage of everything the community centres of Pickering have to offer and plan a visit
          to the one that best fits your family’s needs. </p>

        <br><br>

        <b-img fluid src="/img/blogs/The-Best-Community-Facilites-Near-New-Seaton-01.jpg" alt="Person preparing paint colours" class="mb-15" />


        <p class="subtitle">Culture &amp; Community</p>
        <p>If you’re looking to build friendships with your new neighbours or get more
          involved in your community, Dr. Nelson F. Tomlinson Community Centre is the perfect place to get started.
          Located at 4941 Old Brock Road in Claremont, the community centre was named in honor of Dr. Nelson F.
          Tomilson, a respected community leader who helped build the area’s first school, community centre, park, and
          public library. Today, Dr. Tomilson’s invaluable contributions are echoed by his namesake community centre,
          which features a gym, meeting hall, kitchen, and the Claremont branch of the Pickering Public Library. </p>

        <br><br>

        <b-img fluid src="/img/blogs/The-Best-Community-Facilites-Near-New-Seaton-02.jpg" alt="2 people standing behind a library shelf" class="mb-15" />


        <p>Get to know your new neighbours by attending a book reading at the public library,
          or joining a pick-up game of basketball in the gym. The community centre is a great place to learn about the
          community and develop a new skill or hobby in the process. The Dr. Nelson F. Tomlinson Community Centre is
          also host to the Claremont Lions Club, the Claremont chapter of the largest service organization in the
          world. Anyone can become a member as long as they are of legal age. The club has a focus on giving back to
          the community through fundraisers and community service, supporting local non-profit organizations and
          overall, making a difference in the neighbourhood. </p>
        <a href="https://www.pickering.ca/en/discovering/communitycentres.aspx " target="_blank" class="blog-readmore">Learn
          more about the Pickering Community Centres.</a>

        <br><br><br>

        <b-img fluid src="/img/blogs/The-Best-Community-Facilites-Near-New-Seaton-03.jpg" alt="Basketball net" class="mb-15" />



        <p class="subtitle">Banquet Halls and Meeting Spaces</p>
        <p>Whether you’re planning a wedding or temporarily need a bigger dining room to host
          this year’s annual family reunion, the community centres of Pickering have a place for you. One popular
          choice for parties and receptions is the West Shore Community Centre. Located at 1015 Bayly Street, the
          community centre couldn’t be more picturesque. A beautiful pine lodge overlooking Frenchman’s Bay and
          surrounded by lush green space, the Westshore Community Centre is the perfect venue for outdoor or indoor
          fun, as well as a great backdrop for photos. A similar option to the West Shore Community Centre to look into
          is the George Ashe Library and Community Centre, located at 470 Kingston West. This community centre is
          another gorgeous building featuring floor-to-ceiling windows, an abundance of natural light, and a stunning
          view of the surrounding ravine. Both community centres can accommodate groups of up to 150 people and boast
          plenty of parking and fully appointed kitchens. The East Shore Community Centre is also a popular option due
          to its versatility. This building, located at 910 Liverpool Road South, has three distinct facility spaces
          for rent, which can fit anywhere from 50 to 240 people and prides itself in supplying its guests with
          everything needed for weddings to business meetings, from kitchens, tables and chairs to parking and white
          boards.</p>
        <a href="https://www.pickering.ca/en/discovering/communitycentres.aspx" target="_blank" class="blog-readmore">Learn
          more about available spaces for your next function!</a>

        <br><br><br>

        <b-img fluid src="/img/blogs/The-Best-Community-Facilites-Near-New-Seaton-04.jpg" alt="Pickering Recreation Complex" class="mb-15" />

        <br>

        <p class="subtitle">Fitness and Well Being</p>
        <p>The Pickering Recreation Complex, located at 1867 Valley Farm Road, will quickly
          become your favourite community centre due to its high-quality fitness services and programs the whole family
          can benefit from. In addition to the usual weight room, running track, cardio room, and pool offered by many
          recreation complexes, this one also offers areas to play racquet sports, affordable childcare, physiotherapy,
          nutritional counselling, and fitness classes. Make an event out of your visit to the Pickering Recreation
          Complex by coordinating a new fun fitness class for yourself, like Zumba, with swimming lessons for your
          child. After your classes, relax in one of the many common areas and take advantage of the free Wi-Fi while
          enjoying some delicious snacks and refreshments.</p>

        <br><br>

        <b-img fluid src="/img/blogs/The-Best-Community-Facilites-Near-New-Seaton-05.jpg" alt="Pickering Recreation Complex swimming pool" class="mb-15" />


        <p>The Pickering Recreation Complex is constantly adding new programs and amenities
          throughout the year. With seasonal free-skating and sports tournaments, there is always something new going
          on. The recreation complex also hosts many events and fundraisers throughout the year to keep an eye on. This
          year, the Pickering Recreation Complex hosted a family day event during which they offered delicious food and
          classes meant for all ages to participate in together. The Pickering Recreation Complex is a place always
          buzzing with excitement as it provides energizing classes, programs, and facilities the whole family will
          love taking advantage of.</p>
        <a href="https://www.pickering.ca/en/recreation.aspx" target="_blank" class="blog-readmore">Learn more about
          The Pickering Recreation Complex</a>

        <br><br><br>

        </div>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        this.$root.layout.methods.triggerBlogEnterAnimation(done)
      },
      leave(el, done) {
        this.$root.layout.methods.triggerBlogLeaveAnimation(done)
      },
    },
  }

</script>

<style scoped>

</style>
